import {useEffect} from "react";
import {css} from "@panda/css";
import * as lscache from "lscache";

import {Button} from "@pg-design/button-module";
import {CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {pick} from "@pg-mono/nodash";

import {APPLICATION_LOCAL_STORAGE_KEY} from "../../../app/constants/storage_keys";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {hitNotificationConsentSuccess, hitNotificationConsentView} from "../../../tracking/algolytics_hits/application_hit";
import {gtmEventPostApplicationModal} from "../../../tracking/google_tag_manager/gtm_event_modal";
import {patchApplication} from "../../api/patch_application";
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSourceSection} from "../../utils/form/application_form_source";

interface IProps {
    storeHash: string;
    result: IApplicationData | null;
    onSuccessfulSubmit?: (sentApplication: IApplicationData | null) => void;
    onModalClose: () => void;
    sourceSection: ApplicationSourceSection;
}

export function ApplicationNotificationConsentConfirmationModal(props: IProps) {
    const {storeHash, result, sourceSection, onSuccessfulSubmit, onModalClose} = props;

    const dispatch = useAppDispatch();
    const data = useAppSelector((state) => state.application[storeHash]);
    const viewType = useAppSelector((state) => state.viewType.current);

    useEffect(() => {
        if (data == null) {
            throw new Error("NotusForm componentDidMount: application data should be filled already");
        }

        if (result) {
            // gtm
            gtmEventPostApplicationModal("zgoda marketingowa", "wyswietlenie");
            // algolytics
            hitNotificationConsentView(result, sourceSection, data, {extraPayloadViewType: viewType ?? undefined});
        }
    }, []);

    const onSubmit = () => {
        if (data == null) {
            throw new Error("NotusForm onSubmit: application data should be filled already");
        }

        const newApplication = {...result, marketing_email: true, marketing_sms: true} as IApplicationData | null;
        if (!newApplication || !newApplication.uuid) {
            throw new Error("OfferSubscribe submit: no uuid in result");
        }

        const formInfoToBeSaved = pick(newApplication, ["email", "name", "phone", "marketing_email", "marketing_sms"]);
        patchApplication(
            newApplication.uuid,
            {marketing_email: true, marketing_sms: true},
            storeHash
        )(dispatch).then((application) => {
            if (!application) {
                return;
            }
            // update LS and trigger callback
            lscache.set(APPLICATION_LOCAL_STORAGE_KEY, formInfoToBeSaved);
            onSuccessfulSubmit && onSuccessfulSubmit(newApplication);
            // gtm
            gtmEventPostApplicationModal("zgoda marketingowa", "klikniecie");
            // algolytics
            hitNotificationConsentSuccess({...result, ...application}, sourceSection, data, {
                extraPayloadViewType: viewType ?? undefined
            });
        });
        onModalClose();
    };

    return (
        <div className={bodyHolderStyle}>
            <button type="button" className={closeButtonStyle} onClick={onModalClose}>
                <CloseIcon size="2.4" />
            </button>
            <Text variant="headline_3" as="h1" className={headingStyle}>
                Bądź na bieżąco z najnowszymi inwestycjami i promocjami deweloperskimi!
            </Text>

            <Text variant="body_copy_1" className={subheadingStyle}>
                Kliknij poniższy link, a będziesz pewien, że żadna okazja Cię nie ominie - dowiesz się o niej od razu mailem lub SMSem.
            </Text>

            <Button onClick={onSubmit} variant="filled_primary" className={buttonStyle}>
                Chcę otrzymywać linki do najnowszych ofert
            </Button>

            <Text variant="info_txt_1" align="center" className={grayTextStyle}>
                * możesz dowolnie zmieniać ustawienia tych powiadomień na swoim koncie.
            </Text>
        </div>
    );
}

const bodyHolderStyle = css({
    py: 6,
    px: 2,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    my: 0,
    mx: "auto",
    md: {
        width: "896px",
        height: "auto",
        padding: 5
    }
});

const headingStyle = css({
    marginBottom: 4,
    color: "var(--colors-gray-800)",
    textAlign: "left",
    md: {
        marginBottom: 4,
        textAlign: "center"
    }
});

const subheadingStyle = css({
    color: "var(--colors-gray-800)",
    marginBottom: 8,
    textAlign: "left",
    md: {
        marginBottom: 4,
        textAlign: "center"
    }
});

const buttonStyle = css({
    whiteSpace: "break-spaces",
    marginBottom: 4,
    md: {
        marginBottom: 3
    }
});

const grayTextStyle = css({
    color: "var(--colors-gray-700)"
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: 3,
    right: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    border: "none",
    padding: 0
});
import {useEffect} from "react";
import {css} from "@panda/css";
import * as lscache from "lscache";

import {Button} from "@pg-design/button-module";
import {CloseIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {pick} from "@pg-mono/nodash";

import {APPLICATION_LOCAL_STORAGE_KEY} from "../../../app/constants/storage_keys";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {hitNotificationConsentSuccess, hitNotificationConsentView} from "../../../tracking/algolytics_hits/application_hit";
import {gtmEventPostApplicationModal} from "../../../tracking/google_tag_manager/gtm_event_modal";
import {patchApplication} from "../../api/patch_application";
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSourceSection} from "../../utils/form/application_form_source";

interface IProps {
    storeHash: string;
    result: IApplicationData | null;
    onSuccessfulSubmit?: (sentApplication: IApplicationData | null) => void;
    onModalClose: () => void;
    sourceSection: ApplicationSourceSection;
}

export function ApplicationNotificationConsentConfirmationModal(props: IProps) {
    const {storeHash, result, sourceSection, onSuccessfulSubmit, onModalClose} = props;

    const dispatch = useAppDispatch();
    const data = useAppSelector((state) => state.application[storeHash]);
    const viewType = useAppSelector((state) => state.viewType.current);

    useEffect(() => {
        if (data == null) {
            throw new Error("NotusForm componentDidMount: application data should be filled already");
        }

        if (result) {
            // gtm
            gtmEventPostApplicationModal("zgoda marketingowa", "wyswietlenie");
            // algolytics
            hitNotificationConsentView(result, sourceSection, data, {extraPayloadViewType: viewType ?? undefined});
        }
    }, []);

    const onSubmit = () => {
        if (data == null) {
            throw new Error("NotusForm onSubmit: application data should be filled already");
        }

        const newApplication = {...result, marketing_email: true, marketing_sms: true} as IApplicationData | null;
        if (!newApplication || !newApplication.uuid) {
            throw new Error("OfferSubscribe submit: no uuid in result");
        }

        const formInfoToBeSaved = pick(newApplication, ["email", "name", "phone", "marketing_email", "marketing_sms"]);
        patchApplication(
            newApplication.uuid,
            {marketing_email: true, marketing_sms: true},
            storeHash
        )(dispatch).then((application) => {
            if (!application) {
                return;
            }
            // update LS and trigger callback
            lscache.set(APPLICATION_LOCAL_STORAGE_KEY, formInfoToBeSaved);
            onSuccessfulSubmit && onSuccessfulSubmit(newApplication);
            // gtm
            gtmEventPostApplicationModal("zgoda marketingowa", "klikniecie");
            // algolytics
            hitNotificationConsentSuccess({...result, ...application}, sourceSection, data, {
                extraPayloadViewType: viewType ?? undefined
            });
        });
        onModalClose();
    };

    return (
        <div className={bodyHolderStyle}>
            <button type="button" className={closeButtonStyle} onClick={onModalClose}>
                <CloseIcon size="2.4" />
            </button>
            <Text variant="headline_3" as="h1" className={headingStyle}>
                Bądź na bieżąco z najnowszymi inwestycjami i promocjami deweloperskimi!
            </Text>

            <Text variant="body_copy_1" className={subheadingStyle}>
                Kliknij poniższy link, a będziesz pewien, że żadna okazja Cię nie ominie - dowiesz się o niej od razu mailem lub SMSem.
            </Text>

            <Button onClick={onSubmit} variant="filled_primary" className={buttonStyle}>
                Chcę otrzymywać linki do najnowszych ofert
            </Button>

            <Text variant="info_txt_1" align="center" className={grayTextStyle}>
                * możesz dowolnie zmieniać ustawienia tych powiadomień na swoim koncie.
            </Text>
        </div>
    );
}

const bodyHolderStyle = css({
    py: 6,
    px: 2,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    my: 0,
    mx: "auto",
    md: {
        width: "896px",
        height: "auto",
        padding: 5
    }
});

const headingStyle = css({
    marginBottom: 4,
    color: "var(--colors-gray-800)",
    textAlign: "left",
    md: {
        marginBottom: 4,
        textAlign: "center"
    }
});

const subheadingStyle = css({
    color: "var(--colors-gray-800)",
    marginBottom: 8,
    textAlign: "left",
    md: {
        marginBottom: 4,
        textAlign: "center"
    }
});

const buttonStyle = css({
    whiteSpace: "break-spaces",
    marginBottom: 4,
    md: {
        marginBottom: 3
    }
});

const grayTextStyle = css({
    color: "var(--colors-gray-700)"
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: 3,
    right: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    border: "none",
    padding: 0
});
